import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n        Confirm Request\n      ")
], -1);
const _hoisted_3 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_4 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { class: "p-8 w-1/3" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("p", { class: "text-lg text-gray-800" }, "Comments", -1);
const _hoisted_7 = { class: "divide-y divide-gray-300 divide-solid" };
const _hoisted_8 = { class: "italic" };
const _hoisted_9 = { class: "p-8" };
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("p", null, "Please confirm you would like to submit this request", -1);
const _hoisted_11 = { class: "my-4" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "\n                    Please specify if you would like more info:\n                  ", -1);
const _hoisted_13 = { class: "mt-4 sm:mt-0 sm:col-span-2" };
const _hoisted_14 = { class: "mt-4 flex justify-end" };
const _hoisted_15 = ["disabled"];
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmLeaver',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const formData = ref({});
        const comment = ref('');
        const docId = computed(() => router.currentRoute.value.params.docId);
        const docOwner = computed(() => router.currentRoute.value.params.requestedBy);
        const fetchDocument = async () => {
            store.dispatch('setIsLoading', true);
            const response = await httpClient.post('/bff/get-document', {
                id: docId.value,
                requestedBy: docOwner.value,
            });
            formData.value = response.data.body?.Item ?? {};
            store.dispatch('setIsLoading', false);
        };
        const actionDoc = async (approve) => {
            store.dispatch('setIsLoading', true);
            await httpClient.post('/bff/action-doc', {
                docOwner: docOwner.value,
                id: docId.value,
                approved: approve,
                stage: formData.value.currentStageName,
                comment: comment.value,
            });
            router.go(-2);
            store.dispatch('setIsLoading', false);
        };
        const handleRequestMoreInfo = () => actionDoc('MOREINFO');
        const handleConfirmUser = () => actionDoc('TRUE');
        onMounted(async () => await fetchDocument());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.H2RComments, (commentItem) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                        key: commentItem.timestamp,
                                        class: "text-gray-800 py-2"
                                    }, [
                                        _createElementVNode("span", _hoisted_8, "\"" + _toDisplayString(commentItem.comment) + "\"", 1),
                                        _createTextVNode(" - " + _toDisplayString(commentItem.userEmail), 1)
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("form", null, [
                                    _hoisted_12,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_13, [
                                        _withDirectives(_createElementVNode("textarea", {
                                            id: "comments-input",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((comment).value = $event)),
                                            name: "comments",
                                            rows: "3",
                                            class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                        }, null, 512), [
                                            [_vModelText, comment.value]
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "inline-flex items-center justify-center rounded-md border border-transparent bg-yellow-600 hover:bg-yellow-700 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto disabled:bg-gray-200 disabled:text-gray-500 disabled:cursor-not-allowed",
                                    disabled: !comment.value,
                                    onClick: handleRequestMoreInfo
                                }, "Request more info", 8, _hoisted_15),
                                _createTextVNode(),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "ml-2 inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                    onClick: handleConfirmUser
                                }, "Confirm")
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
